import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import getBrowserLocales from "./locales/browserLocales";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: getBrowserLocales()?.[0],
  resources: {
    en: {
      translations: require("./locales/en/resources.json"),
    },
    fr: {
      translations: require("./locales/fr/resources.json"),
    },
  },

  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "fr"];

export default i18n;
